require('regenerator-runtime/runtime');

(() => {
    function addExitIntentEvent() {
        const event = new Event('exitIntent');

        if (768 > window.innerWidth) {
            // On mobile, detect a small scroll up to get the browser navigation bar
            const scrollTriggerFloor = document.body.clientHeight * 0.01;
            const scrollTriggerCeiling = document.body.clientHeight * 0.03;
            let lastPosition = 0;

            const checkScrollInterval = setInterval(() => {
                const scrollDistance = lastPosition - window.scrollY;

                if (scrollDistance > scrollTriggerFloor && scrollDistance < scrollTriggerCeiling) {
                    document.dispatchEvent(event);
                    clearInterval(checkScrollInterval);
                }

                lastPosition = window.scrollY;
            }, 333);

        } else {
            // On desktop, fire event if the user leaves the document to close the tab
            document.addEventListener('mouseout', function handler(e) {
                if (!e.toElement && !e.relatedTarget) {
                    document.dispatchEvent(event);
                    document.removeEventListener('mouseout', handler);
                }
            });
        }
    }

    function areTimeRulesActive(campaign) {
        return isStartTimeRuleActive(campaign) && isEndTimeRuleActive(campaign);
    }

    function isStartTimeRuleActive(campaign) {
        if (typeof campaign.startTime !== 'undefined') {
            return campaign.startTime <= Date.now();
        }
        return true;
    }

    function isEndTimeRuleActive(campaign) {
        if (typeof campaign.endTime !== 'undefined') {
            return campaign.endTime >= Date.now();
        }
        return true;
    }

    function isViewportRuleActive(campaign) {
        if (typeof campaign.viewports !== 'undefined') {
            const width = window.innerWidth;
            const { viewports } = campaign;

            if (width < 768) {
                return viewports.includes('xs');
            }

            if (width > 767 && width < 992) {
                return viewports.includes('md');
            }

            if (width > 991 && width < 1200) {
                return viewports.includes('lg');
            }

            if (width > 1199) {
                return viewports.includes('xl');
            }
        }
        return false;
    }

    function isGeolocationRuleActive(campaign) {
        if (typeof campaign.countries !== 'undefined') {
            const { countries, geolocationDefault } = campaign;
            const userCountry = getUserCountry();

            if ('' === userCountry) {
                return geolocationDefault;
            }

            return countries.includes(userCountry);
        }

        return true;
    }

    async function loadUserCountry() {
        if (cookieExists('fl_ccc') && getCookieValue('fl_ccc') !== '') {
            window.flexiMonster.userCountry = getCookieValue('fl_ccc');
        }

        let userCountry = '';
        await fetch('/geo-info')
            .then(async (response) => {
                const data = await response.json();
                userCountry = data.geo.country_code || '';
            })
            .catch(() => {})

        window.flexiMonster.userCountry = userCountry;
        document.cookie = `fl_ccc=${userCountry}; path=/; max-age=${3600 * 24 * 30};`; // 30 days
    }

    function getUserCountry() {
        return window.flexiMonster.userCountry;
    }

    function isCookieRuleActive(campaign) {
        if (typeof campaign.cookieTargeting !== 'undefined') {
            const { cookieTargeting } = campaign;
            const rule = typeof cookieTargeting.rule !== 'undefined' ? cookieTargeting.rule : 'disabled';
            const key = typeof cookieTargeting.key !== 'undefined' ? cookieTargeting.key : '';
            const value = typeof cookieTargeting.value !== 'undefined' ? cookieTargeting.value : '';

            switch (rule) {
                case 'key_present':
                    return cookieExists(key);

                case 'key_absent':
                    return !cookieExists(key);

                case 'key_has_value':
                    return cookieExists(key) && getCookieValue(key) === value;

                case 'key_has_not_value':
                    return cookieExists(key) && getCookieValue(key) !== value;

                default:
                    return true;
            }
        }
        return true;
    }

    function cookieExists(cookieName) {
        return typeof getCookies()[cookieName] !== 'undefined';
    }

    function getCookieValue(cookieName) {
        return getCookies()[cookieName] || '';
    }

    function getCookies() {
        const cookiesObj = {};
        const cookies = document.cookie ? document.cookie.split('; ') : [];

        for (let i = 0; i < cookies.length; i += 1) {
            const cookie = cookies[i].split('=');
            cookiesObj[decodeURIComponent(cookie[0])] = decodeURIComponent(cookie[1]);
        }

        return cookiesObj;
    }

    function isCampaignShownRuleActive(campaign) {
        return isCounterBasedRuleActive('timesShown', 'timesShownExpiration', 'fmcc', campaign);
    }

    function isUserConvertedRuleActive(campaign) {
        return isCounterBasedRuleActive('timesConverted', 'timesConvertedExpiration', 'fmcc_c', campaign);
    }

    function isCounterBasedRuleActive(ruleMaxProperty, ruleExpirationProperty, counterLocalStorageKey, campaign) {
        if (typeof campaign[ruleMaxProperty] !== 'undefined') {
            const campaignCounter = getCampaignCounter(counterLocalStorageKey, campaign.id);
            const timesShownRule = campaign[ruleMaxProperty] || 1;
            const timesShownRuleExpiration = campaign[ruleExpirationProperty] || 0;

            // The actual moment when the rule has expired (8.64e7 = milliseconds in a day)
            const timesShownRuleExpirationDate = campaignCounter.d + timesShownRuleExpiration * 8.64e7;

            if (campaignCounter.t >= timesShownRule) {
                if (timesShownRuleExpiration && Date.now() >= timesShownRuleExpirationDate) {
                    // rule has expired
                    setCampaignCounter('fmcc', campaign.id, 0, Date.now());
                    return true;
                }

                // Rule has kicked in, the total number of times shown is larger than the set maximum
                return false;
            }

            // Rule has not kicked in, the total number of times shown is less than the set maximum
            return true;
        }

        // no rule set
        return true;
    }

    function recordCampaignShown(campaignId) {
        const campaignCounter = getCampaignCounter('fmcc', campaignId);
        setCampaignCounter('fmcc', campaignId, campaignCounter.t + 1, Date.now());
    }

    function recordCampaignConverted(campaignId) {
        const campaignCounter = getCampaignCounter('fmcc_c', campaignId);
        setCampaignCounter('fmcc_c', campaignId, campaignCounter.t + 1, Date.now());
    }

    function getCampaignCounter(counterLocalStorageKey, campaignId) {
        const globalCampaignCounter = JSON.parse(window.localStorage.getItem(counterLocalStorageKey)) || {};
        return globalCampaignCounter[campaignId] || { t: 0, d: 0 };
    }

    function setCampaignCounter(counterLocalStorageKey, campaignId, timesShown, dateShown) {
        const globalCampaignCounter = JSON.parse(window.localStorage.getItem(counterLocalStorageKey)) || {};
        globalCampaignCounter[campaignId] = {
            t: timesShown,
            d: dateShown,
        };
        localStorage.setItem(counterLocalStorageKey, JSON.stringify(globalCampaignCounter));
    }

    function displayInlineCampaign(campaign) {
        addStyleTags(campaign.cssUrls);
        addScriptTags(campaign.jsUrls);
        const $placeholders = document.querySelectorAll(`[data-fm-insert-campaign='${campaign.id}']`);

        for (const $placeholder of $placeholders) {
            $placeholder.className = `flexi-monster-campaign inline campaign-${campaign.id}`;
            $placeholder.innerHTML = campaign.html;
            addConversionTracker($placeholder, campaign.id);
        }
    }

    function displayOverlayCampaign(campaign) {
        switch (campaign.displayRule.rule) {
            case 'on_scroll': {
                displayOverlayCampaignOnScroll(campaign);
                break;
            }
            case 'exit_intent': {
                displayOverlayCampaignOnExitIntent(campaign);
                break;
            }
            default: { // on_load
                displayOverlayCampaignOnLoad(campaign);
                break;
            }
        }
    }

    function displayOverlayCampaignOnScroll(campaign) {
        document.addEventListener('scroll', function handler() {
            const displayScrollDistance = parseFloat(campaign.displayRule.properties.topDistance) || 0.05;
            const currentScrollDistance = window.scrollY / (document.body.clientHeight - window.innerHeight);

            if (displayScrollDistance <= currentScrollDistance) {
                injectOverlayCampaign(campaign);
                document.removeEventListener('scroll', handler);
            }
        });
    }

    function displayOverlayCampaignOnExitIntent(campaign) {
        document.addEventListener('exitIntent', function handler() {
            injectOverlayCampaign(campaign);
            document.removeEventListener('exitIntent', handler);
        });
    }

    function displayOverlayCampaignOnLoad(campaign) {
        const delay = parseInt(campaign.displayRule.properties.delay, 10) || 0;
        setTimeout(() => {
            injectOverlayCampaign(campaign);
        }, delay);
    }

    function injectOverlayCampaign(campaign) {
        recordCampaignShown(campaign.id);

        addOverlayHtml(campaign.html, campaign.id);
        addStyleTags(campaign.cssUrls);
        addScriptTags(campaign.jsUrls);
    }

    function addOverlayHtml(html, id) {
        const $div = document.createElement('div');
        $div.id = `fm-c${id}`;
        $div.className = `flexi-monster-campaign overlay campaign-${id}`;
        $div.setAttribute('data-eventcategory', 'fm-element');
        $div.insertAdjacentHTML('afterbegin', html);
        addConversionTracker($div, id);
        addClosingButton($div, id);
        addClosingButtonWithConversion($div, id);
        document.body.appendChild($div);
    }

    function addConversionTracker($element, campaignId) {
        for (const $cta of $element.querySelectorAll('[data-fm="conversion"]')) {
            $cta.addEventListener('click', () => {
                recordCampaignConverted(campaignId);
            });
        }
    }

    function addClosingButton($element) {
        const $campaignDiv = $element;

        for (const $closingButton of $campaignDiv.querySelectorAll('[data-fm="close"]')) {
            $closingButton.addEventListener('click', () => {
                $campaignDiv.style.display = 'none';
            });
        }
    }

    function addClosingButtonWithConversion($element, campaignId) {
        const $campaignDiv = $element;

        for (const $cta of $campaignDiv.querySelectorAll('[data-fm="conversion-close"]')) {
            $cta.addEventListener('click', () => {
                recordCampaignConverted(campaignId);
            });

            $cta.addEventListener('click', () => {
                $campaignDiv.style.display = 'none';
            });
        }
    }

    function addStyleTags(cssUrls) {
        for (const cssUrl of cssUrls) {
            const link = document.createElement('link');
            link.href = cssUrl;
            link.type = 'text/css';
            link.rel = 'stylesheet';
            document.head.appendChild(link);
        }
    }

    function addScriptTags(jsUrls) {
        for (const jsUrl of jsUrls) {
            const script = document.createElement('script');
            script.src = jsUrl;
            document.body.appendChild(script);
        }
    }

    function isCampaignTargeted(campaign) {
        return (
            areTimeRulesActive(campaign)
            && isViewportRuleActive(campaign)
            && isCookieRuleActive(campaign)
            && isGeolocationRuleActive(campaign)
            && isCampaignShownRuleActive(campaign)
            && isUserConvertedRuleActive(campaign)
        );
    }

    async function main() {
        if (typeof window.flexiMonster !== 'undefined') {
            await loadUserCountry();
            addExitIntentEvent();

            for (const campaign of window.flexiMonster.overlayCampaigns) {
                if (isCampaignTargeted(campaign)) {
                    displayOverlayCampaign(campaign);
                }
            }

            for (const campaign of window.flexiMonster.inlineCampaigns) {
                if (isCampaignTargeted(campaign)) {
                    displayInlineCampaign(campaign);
                }
            }
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', async () => {
            main();
        });
    } else {
        main();
    }
})();
